"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeAllRelatedNodes = exports.ChangeRelatedNode = void 0;
exports.ChangeRelatedNode = ({ newName, node, oldName, }) => {
    if (node.type.name === oldName) {
        node.type.name = newName;
    }
    if (node.args) {
        node.args.forEach((n) => exports.ChangeRelatedNode({ oldName, newName, node: n }));
    }
};
exports.ChangeAllRelatedNodes = ({ newName, nodes, oldName, }) => {
    nodes.forEach((n) => exports.ChangeRelatedNode({ oldName, newName, node: n }));
};
